<template>
  <b-col sm="12">
    <HotelInfo :info="result.hotelInfo" />
    <b-row v-if="showPrices">
      <b-col sm="12" class="noPrint">
        <Legend/>
      </b-col>
      <b-col sm="12">
        <b-table-simple stacked="sm" striped class="table table-sm mb-0">
          <b-thead class="t-head thead-light">
            <b-tr>
              <b-th v-translate>Category</b-th>
              <b-th v-translate>Board basis</b-th>
              <b-th v-translate>Booking price</b-th>
              <b-th v-translate>Price</b-th>
              <b-th colspan="3"></b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <template v-for="category in result.categories">
              <Category
                :category="category"
                :currency="currency"
                :result="result"
                :showCollapse="false"
                :showBook="false"
                :fees="fees"
                :starRating="result.stars"
                :key="'categoryInfo' + category.id" />
            </template>
          </b-tbody>
        </b-table-simple>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import HotelInfo from '@/app/private/shared/components/hotel_info'
import Category from '@/app/private/shared/components/category_info'
import Legend from '@/app/private/shared/components/legend'

export default {
  name: 'detailedInfo',
  props: {
    result: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    showPrices: {
      type: Boolean,
      required: false,
      default: true
    },
    fees: {
      type: Object,
      default: () => { return {} }
    }
  },
  components: { HotelInfo, Category, Legend }
}
</script>

<style lang="scss" scoped>

</style>
